import { render, staticRenderFns } from "./approval_rules_wrapper.vue?vue&type=template&id=5738988f"
import script from "./approval_rules_wrapper.vue?vue&type=script&lang=js"
export * from "./approval_rules_wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports